// TODO: DEPRECATED due the incorrect "text" name
import { AgTextFieldRenderer, getTextFieldRendererTemplate, textFieldRendererStyles, } from './text-field.renderer';
/**
 * @public
 * @deprecated - Use AgTextFieldRenderer instead
 * @tagname %%prefix%%-grid-text-renderer
 */
export class AgTextRenderer extends AgTextFieldRenderer {
}
/**
 * @public
 * @deprecated - Use textFieldRendererStyles instead
 */
export const textRendererStyles = textFieldRendererStyles;
/**
 * @public
 * @deprecated - Use getTextFieldRendererTemplate instead
 */
export const getTextRendererTemplate = getTextFieldRendererTemplate;
/**
 * A function that returns a Foundation Text Renderer registration for configuring the component with a DesignSystem.
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-grid-text-renderer\>
 * @deprecated - Use foundationAgTextFieldRenderer instead
 */
export const foundationAgTextRenderer = AgTextRenderer.compose({
    baseName: 'grid-text-renderer',
    styles: textRendererStyles,
    template: getTextRendererTemplate(),
});
